import { useEffect } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import SelectBox from 'components/form/SelectBox'
import {
  fetchCampaigns,
  selectCampaign,
  selectChannel,
  setCampaigns,
} from 'features/editlog/editlogSlice'

const CampaignFilter = () => {
  const dispatch = useDispatch()
  const {
    channels,
    campaigns,
    selectedCampaign,
    selectedChannel,
    isLoading,
    hasCampaigns,
  } = useSelector(state => state.editlog)

  const onClickFetchCampaigns = () => {
    if (selectedChannel) {
      const filteredCampaigns = campaigns.filter(
        c => c.bizChannelId === selectedChannel.id
      )
      if (selectedCampaign && filteredCampaigns.length) {
        dispatch(setCampaigns(filteredCampaigns))
      }
    } else {
      if (!selectedCampaign) {
        dispatch(fetchCampaigns())
      }
    }
  }

  useEffect(() => {
    if (!selectedCampaign) {
      dispatch(fetchCampaigns(selectedChannel))
    }
  }, [dispatch, selectedCampaign, selectedChannel])
  return (
    <SelectBox
      placeholder="캠페인 선택"
      value={selectedCampaign}
      onValueChange={v => {
        if (v) {
          batch(() => {
            dispatch(
              selectChannel(channels.find(ch => ch.id === v.bizChannelId))
            )
            dispatch(selectCampaign(v))
          })
        }
      }}
      disabled={isLoading || !hasCampaigns}
      onClick={onClickFetchCampaigns}>
      {campaigns.map(campaign => (
        <SelectBox.Item key={campaign.id} value={campaign}>
          {campaign.name} {campaign.deletedDate && '(삭제)'}
        </SelectBox.Item>
      ))}
    </SelectBox>
  )
}

export default CampaignFilter
